import { openbetHttpClient } from "@/api/openbet-http-client";
import { AuthResult, Token } from "@/shared/model/auth";
import { appendEnvSuffix } from "@/api/http-client-helpers";
import { oidcSettings } from "@/shared/composables/use-auth-service";

const path = appendEnvSuffix("/iam-service");

export async function getToken(authResult: AuthResult) {
    const { client_id, redirect_uri } = oidcSettings;
    const response = await openbetHttpClient.post<Token>(
        `${path}/token`,
        {
            client_id,
            redirect_uri,
            grant_type: "authorization_code",
            code: authResult.code,
        },
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } },
    );
    return response?.data;
}
